const BigShadow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="91"
    height="8"
    viewBox="0 0 91 8"
  >
    <path
      fill="#DDDDE5"
      d="M90.9 3.938c0 .85-4.174 1.619-11.066 2.208-2.074.179-3.988.736-6.1.793-9.324.269-18.694.371-28.032.371-9.337 0-18.528-.179-27.782-.723C16.358 6.497.5 6.21.5 3.937c0-1.036 6.002-1.094 15.897-1.708 3.84-.243 7.68-1.165 11.565-1.383C33.869.514 39.789.571 45.702.571c4.87 0 9.69.736 14.554.89 2.957.09 8.32-.435 10.918-.301 1.741.09 19.725.41 19.725 2.778z"
    />
  </svg>
);

export default BigShadow;
